import {format} from 'date-fns';
import {formatoNumeroDecimal} from 'lib.common/dist/numeros';
import {
   ObjectStrKeys,
   PtrnCampoLecturaFloat,
   PtrnCampoLecturaFnGenValorMostrar,
   PtrnTiposCampo
} from '../../patronTypes';
import {FORMATS} from '../../constants';

const CampoLecturaToStringMap: {[k: string]: PtrnCampoLecturaFnGenValorMostrar} = {
   [PtrnTiposCampo.date]: (value: Date | null) => (value ? format(value, FORMATS.date) : ''),
   [PtrnTiposCampo.time]: (value: Date) => format(value, FORMATS.time),
   [PtrnTiposCampo.datetime]: (value: Date) => format(value, FORMATS.datetime),
   // @ts-ignore
   [PtrnTiposCampo.float]: (
      value: number,
      auxParam?: {camposData?: ObjectStrKeys; index?: number; campoConfig: PtrnCampoLecturaFloat}
   ) => {
      if (
         auxParam &&
         auxParam.campoConfig &&
         auxParam.campoConfig.maxDigitosDecimales &&
         auxParam.campoConfig.maxDigitosDecimales > 0
      ) {
         return formatoNumeroDecimal(value, {
            cifrasDecimales: auxParam.campoConfig.maxDigitosDecimales
         }).formato;
      }
      return value.toString();
   }
};
export default CampoLecturaToStringMap;
